import FooterCenteredLayout from './FooterCenteredLayout'

function FooterCenteredDark({ config }) {
  return <FooterCenteredLayout config={config} variant="dark" showSocial />
}

export default FooterCenteredDark
